<template>
    <div id="Consolenew_site" :class="IsShow?'':'hidden'">
        <div class="Consolenew-heade">
            <b>站点列表</b>
            <span class="text-a"> &nbsp;</span>
            <span class="text-b"> &nbsp; </span>
        </div>
        <div class="text-data">
            <el-table :header-cell-style="{background:'#02142a',color:'cornflowerblue',border:'1px solid #000'}" element-loading-text="加载中" element-loading-background="rgba(0, 0, 0, 0.6)" :cell-style="{border:'1px solid #000',cursor:'pointer'}" :data="SiteData" ref="Sitetable" border  style="width: 100%" height="100%" @row-click="rowclick">
                <el-table-column prop="siteName" label="站点名称" width="200" sortable>
                </el-table-column>
                <el-table-column prop="lightBoxNum" label="媒体数" width="140" sortable>
                </el-table-column>
                <el-table-column prop="siteAddress" label="地址" width="235" sortable>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Consolenew_site',
    props: {
        SiteId: {
            type: Number,
            default: 1
        },
        IsShow: {
            type: Boolean,
            default: true
        },
        SiteData: {
            type: Array,
            default: []
        }
    },
    data: function() {
        return {
            searchform: {
                siteid: "",
            },
            Site_Id: 1,
            tableData: [],
            on_line: 0,
            no_line: 0,
            loading: true,
            currentRow: null
        }
    },
    methods: {
        getDetails(row) {
            this.$store.commit("setADId", row.aDId);
            this.$emit("changeAd");
        },
        rowclick(row){
            this.$emit("showMap",row);
        },
        initData() {},
        initParamsData() {},
    },
    created() {
        //this.initData();
        //this.initParamsData();
    }
};
</script>
<style>
#Consolenew_site {
    position: relative;
    background: url("../../assets/device_bg.png");
    background-size: 100% 100%;
    background-position: center center;
    width: 98.5%;
    height: 66%;
    margin-top: 20px;
}

#Consolenew_site .el-table__empty-block {
    background-color: #02142a;
}

#Consolenew_site .el-table__body-wrapper {
    background-color: #02142a;
}
#Consolenew_site .text-data {
    position: absolute;
    width: 96%;
    height: 88%;
    overflow: hidden;
    margin-left: 2%;
    margin-top: 8%;
}
#Consolenew_site .text-data .el-table {
    border-bottom: 0px;
}
#Consolenew_site .el-table--border::after,#Consolenew_site .el-table--group::after,#Consolenew_site .el-table::before{
    background-color: transparent;
}
#Consolenew_site .el-table__row:hover{
    background-color:#6495ed;
}
</style>